import React from 'react';

const Help = props => {
    return props => <iframe src="https://invintus-support.freshdesk.com/support/solutions" width="100%" height="900px" frameBorder="0"/>
}

export default Help;
